import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useMemo, useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Card, CardBody, Row, Col, Form, Button, Modal } from "react-bootstrap";
import { Stack } from "@mui/material";
import Select from "react-select";
import { Formik } from "formik";
import DownloadExcel from "utils/DownloadExcel";
import DataTableLayout from "layouts/DatatableLayout";
import { ModalAllder } from "layouts/ModalAllder";
import * as yup from "yup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import { nanoid } from "nanoid";
import moment from "moment";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { NumberFormat } from "utils/HelperFunction";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { allPromotion } from "../../redux/handlers/manage/allPromotion.handler";
import { allPromotionByID } from "../../redux/handlers/manage/allPromotionByID.handler";
import { mstPromoType } from "../../redux/handlers/manage/mstPromoType.handler";
import { createPromotion, clearcreatePromotion } from "../../redux/handlers/manage/createPromotion.handler";
import { updatePromotion, clearupdatePromotion } from "../../redux/handlers/manage/updatePromotion.handler";
import { deletePromotion, cleardeletePromotion } from "../../redux/handlers/manage/deletePromotion.handler";
export function Promotion() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(""), 2), filterText = _useState[0], setFilterText = _useState[1];
    var _useState1 = _sliced_to_array(useState(""), 2), modelText = _useState1[0], setmodelText = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), filteredItems = _useState2[0], setFilteredItems = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), rowData = _useState3[0], setRowData = _useState3[1];
    var _useState4 = _sliced_to_array(useState(false), 2), modalsuccess = _useState4[0], setModalsuccess = _useState4[1];
    var _useState5 = _sliced_to_array(useState(false), 2), textsuccess = _useState5[0], setTextsuccess = _useState5[1];
    var _useState6 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 10,
        width: 500,
        height: 300,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modalDel = _useState6[0], setModalDel = _useState6[1];
    var allPromotionReducer = useAppSelector(function(state) {
        return state.allPromotionReducer;
    });
    useEffect(function() {
        dispatch(allPromotion({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, []);
    useEffect(function() {
        setIsLoading(allPromotionReducer.isFetching);
        if (allPromotionReducer.data) {
            var data = allPromotionReducer.data.data;
            setRowData(data);
            setFilteredItems(data);
        }
    }, [
        allPromotionReducer
    ]);
    useEffect(function() {
        if (filterText) {
            setRowData(filteredItems.filter(function(item) {
                return item.set_promotion_name && item.set_promotion_name.toLowerCase().includes(filterText.toLowerCase());
            }));
        } else {
            setRowData(filteredItems);
        }
    }, [
        rowData,
        filterText
    ]);
    var columns = [
        {
            name: "รหัสโปรโมชัน",
            selector: function(row) {
                return row.set_promotion_code ? row.set_promotion_code : "-";
            },
            center: "true"
        },
        {
            name: "ชื่อรายการ",
            selector: function(row) {
                return row.set_promotion_name;
            },
            center: "true"
        },
        {
            name: "วันเริ่มต้น",
            selector: function(row) {
                return row.set_promotion_sdate ? moment(row.set_promotion_sdate).format("DD/MM/YYYY") : "-";
            },
            center: "true"
        },
        {
            name: "วันสิ้นสุด",
            selector: function(row) {
                return row.set_promotion_edate ? moment(row.set_promotion_edate).format("DD/MM/YYYY") : "-";
            },
            center: "true"
        },
        {
            name: "ราคา/ส่วนลด",
            selector: function(row) {
                return row.set_promotion_type == 1 || row.set_promotion_type == 2 ? NumberFormat(row.set_promotion_discount ? row.set_promotion_discount : 0, 2) : row.set_promotion_buy + "+" + row.set_promotion_free;
            },
            center: "true"
        },
        {
            name: "ประเภท",
            selector: function(row) {
                return row.SetPromotype.set_promotype_name;
            },
            // (row.set_promotion_type == 1 && "บาท") ||
            // (row.set_promotion_type == 2 && "เปอร์เซ็นต์") ||
            // (row.set_promotion_type == 3 && "แถม"),
            center: "true"
        },
        {
            name: "หมายเหตุ",
            selector: function(row) {
                return row.set_promotion_remark ? row.set_promotion_remark : "-";
            },
            center: "true"
        },
        {
            name: "สถานะ",
            selector: function(row) {
                return row.set_promotion_status;
            },
            center: "true",
            cell: function(row, index, column, id) {
                return row.set_promotion_status == 1 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#10B02A",
                        backgroundColor: "rgba(238, 251, 229, 1)",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "ใช้งาน"
                }) || row.set_promotion_status == 2 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#F95057",
                        backgroundColor: "#FFE3E3",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "ไม่ใช้งาน"
                });
            }
        },
        {
            name: "จัดการ",
            selector: function(row) {
                return row.set_promotion_id;
            },
            center: "true",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx(Link, {
                            to: "/promotion/manage/".concat(row.set_promotion_id),
                            style: {
                                marginRight: 5
                            },
                            children: /*#__PURE__*/ _jsx(EditIcon, {
                                style: {
                                    color: "#797A7A",
                                    fontSize: 30,
                                    borderRadius: 40,
                                    background: "#E9E9E9",
                                    padding: 5
                                }
                            })
                        }),
                        /*#__PURE__*/ _jsx(Link, {
                            onClick: function() {
                                setModalDel(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true,
                                        typeData: "deletePromotion",
                                        data: {
                                            id: row.set_promotion_id,
                                            name: row.set_promotion_name
                                        }
                                    });
                                });
                                setmodelText("ยืนยันลบโปรโมชัน");
                            },
                            style: {
                                marginRight: 3
                            },
                            children: /*#__PURE__*/ _jsx(DeleteOutline, {
                                style: {
                                    fontSize: 30,
                                    borderRadius: 40,
                                    background: "rgb(255, 227, 227)",
                                    color: "#FF0000",
                                    padding: 5
                                }
                            })
                        })
                    ]
                });
            }
        }
    ];
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการ"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการโปรโมชัน"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2",
                        children: "จัดการโปรโมชัน"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsxs(Card, {
                    children: [
                        /*#__PURE__*/ _jsx(CardBody, {
                            children: /*#__PURE__*/ _jsxs(Row, {
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 8,
                                        lg: 7,
                                        children: /*#__PURE__*/ _jsx(DownloadExcel, {
                                            data: rowData,
                                            filename: "โปรโมชัน"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 8,
                                        lg: 5,
                                        children: /*#__PURE__*/ _jsxs(Stack, {
                                            direction: "horizontal",
                                            children: [
                                                /*#__PURE__*/ _jsx("input", {
                                                    type: "text",
                                                    className: "form-control me-3",
                                                    placeholder: "ค้นหาโปรโมชัน",
                                                    onKeyUp: function(e) {
                                                        return setFilterText(e.target.value);
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Link, {
                                                    className: "btn btn-dg w-[200px]",
                                                    to: "/promotion/manage",
                                                    children: "สร้างโปรโมชัน"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(DataTableLayout, {
                            item: rowData,
                            columns: columns,
                            isSelectRows: false,
                            PerPage: 10
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalDel,
                setModal: setModalDel,
                htitle: modelText,
                hbtn: true,
                children: /*#__PURE__*/ _jsx(DelModel, {
                    setModal: setModalDel,
                    modal: modalDel,
                    setModalsuccess: setModalsuccess,
                    setTextsuccess: setTextsuccess,
                    setIsLoading: setIsLoading,
                    setModalObj: setModalObj,
                    modalObj: modalObj
                })
            })
        ]
    });
}
export function PromotionManage() {
    var param = useParams();
    var dataID = useMemo(function() {
        return param.dataID ? param.dataID : null;
    }, [
        param.dataID
    ]);
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState({}), 2), formdata = _useState[0], setFormdata = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), optionsMstPromotionType = _useState1[0], setoptionsMstPromotionType = _useState1[1];
    var _useState2 = _sliced_to_array(useState([
        {
            value: 6,
            label: "ชิ้น"
        },
        {
            value: 4,
            label: "แพ็ค"
        },
        {
            value: 7,
            label: "ลัง"
        }
    ]), 2), optionsMstUnit = _useState2[0], setoptionsMstUnit = _useState2[1];
    var _useState3 = _sliced_to_array(useState(false), 2), formdisabled = _useState3[0], setFormdisabled = _useState3[1];
    var _useState4 = _sliced_to_array(useState(false), 2), textsuccess = _useState4[0], setTextsuccess = _useState4[1];
    var _useState5 = _sliced_to_array(useState(false), 2), modalsuccess = _useState5[0], setModalsuccess = _useState5[1];
    var _useState6 = _sliced_to_array(useState(1), 2), status = _useState6[0], setStatus = _useState6[1];
    var schema = yup.object().shape({
        set_promotion_code: yup.string().required(),
        set_promotion_name: yup.string().required(),
        set_promotion_sdate: yup.string().required(),
        set_promotion_edate: yup.string().required(),
        set_promotion_discount: yup.string().when("set_promotion_type", {
            is: function(type) {
                return type === "1" || type === "2";
            },
            then: function(schema) {
                return schema.required("Discount is required");
            },
            otherwise: function(schema) {
                return schema.notRequired();
            }
        }),
        set_promotion_unitid: yup.string().when("set_promotion_type", {
            is: function(type) {
                return type === "1" || type === "2";
            },
            then: function(schema) {
                return schema.required("Level is required");
            },
            otherwise: function(schema) {
                return schema.notRequired();
            }
        }),
        set_promotion_buy: yup.string().when("set_promotion_type", {
            is: function(type) {
                return type === "3";
            },
            then: function(schema) {
                return schema.required("Buy is required");
            },
            otherwise: function(schema) {
                return schema.notRequired();
            }
        }),
        set_promotion_free: yup.string().when("set_promotion_type", {
            is: function(type) {
                return type === "3";
            },
            then: function(schema) {
                return schema.required("Free is required");
            },
            otherwise: function(schema) {
                return schema.notRequired();
            }
        }),
        set_promotion_type: yup.string().required()
    });
    var mstPromoTypeReducer = useAppSelector(function(state) {
        return state.mstPromoTypeReducer;
    });
    var createPromotionReducer = useAppSelector(function(state) {
        return state.createPromotionReducer;
    });
    var updatePromotionReducer = useAppSelector(function(state) {
        return state.updatePromotionReducer;
    });
    var allPromotionByIDReducer = useAppSelector(function(state) {
        return state.allPromotionByIDReducer;
    });
    useEffect(function() {
        dispatch(mstPromoType({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        if (dataID) {
            dispatch(allPromotionByID(parseInt(dataID), {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    }, []);
    useEffect(function() {
        setIsLoading(mstPromoTypeReducer.isFetching || createPromotionReducer.isFetching || updatePromotionReducer.isFetching || allPromotionByIDReducer.isFetching);
        if (mstPromoTypeReducer.data) {
            var Promo = [];
            mstPromoTypeReducer.data.data.map(function(ele) {
                return Promo.push({
                    value: ele.set_promotype_id,
                    label: ele.set_promotype_name
                });
            });
            setoptionsMstPromotionType(Promo);
        }
        if (createPromotionReducer.data && !createPromotionReducer.isError) {
            setTextsuccess("สร้างโปรโมชัน");
            setModalsuccess(true);
            dispatch(clearcreatePromotion());
            navigate("/promotion");
        }
        if (updatePromotionReducer.data && !updatePromotionReducer.isError) {
            setTextsuccess("สร้างโปรโมชัน");
            setModalsuccess(true);
            dispatch(clearupdatePromotion());
            navigate("/promotion");
        }
        if (dataID) {
            if (allPromotionByIDReducer.data) {
                var promoData = allPromotionByIDReducer.data.data;
                var data = {
                    set_promotion_code: promoData.set_promotion_code,
                    set_promotion_discount: promoData.set_promotion_discount ? promoData.set_promotion_discount : 0,
                    set_promotion_unitid: promoData.set_promotion_unitid ? promoData.set_promotion_unitid : null,
                    set_promotion_buy: promoData.set_promotion_buy ? promoData.set_promotion_buy : "",
                    set_promotion_free: promoData.set_promotion_free ? promoData.set_promotion_free : "",
                    set_promotion_edate: new Date(promoData.set_promotion_edate),
                    set_promotion_id: promoData.set_promotion_id,
                    set_promotion_name: promoData.set_promotion_name,
                    set_promotion_remark: promoData.set_promotion_remark ? promoData.set_promotion_remark : "",
                    set_promotion_sdate: new Date(promoData.set_promotion_sdate),
                    set_promotion_status: promoData.set_promotion_status,
                    set_promotion_type: promoData.set_promotion_type
                };
                setStatus(promoData.set_promotion_status);
                setFormdata(data);
            }
        }
    }, [
        mstPromoTypeReducer,
        createPromotionReducer,
        updatePromotionReducer,
        allPromotionByIDReducer
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการ"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการโปรโมชัน"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2",
                        children: dataID ? "แก้ไขโปรโมชัน" : "สร้างโปรโมชัน"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Formik, {
                enableReinitialize: true,
                initialValues: formdata,
                validationSchema: schema,
                validateOnMount: true,
                onSubmit: function(values) {
                    var formdataPayload = new FormData();
                    console.log("formdataPayload", formdataPayload);
                    console.log("values", values);
                    if (values.set_promotion_type == 3) {
                        values.set_promotion_discount = 0;
                        values.set_promotion_unitid = null;
                    } else if (values.set_promotion_type == 1 || values.set_promotion_type == 2) {
                        values.set_promotion_buy = 0;
                        values.set_promotion_free = 0;
                    }
                    if (!dataID) {
                        var create = _object_spread_props(_object_spread({}, values), {
                            set_promotion_discount: parseFloat(values.set_promotion_discount),
                            set_promotion_status: status
                        });
                        dispatch(createPromotion(create, {
                            modalObj: modalObj,
                            setModalObj: setModalObj
                        }));
                    } else {
                        var edit = _object_spread_props(_object_spread({}, values), {
                            set_promotion_discount: parseFloat(values.set_promotion_discount),
                            set_promotion_status: status
                        });
                        dispatch(updatePromotion(edit, {
                            modalObj: modalObj,
                            setModalObj: setModalObj
                        }));
                    }
                },
                children: function(param) {
                    var handleSubmit = param.handleSubmit, handleChange = param.handleChange, touched = param.touched, errors = param.errors, values = param.values, setFieldValue = param.setFieldValue, setValues = param.setValues, isInvalid = param.isInvalid, isValid = param.isValid;
                    return /*#__PURE__*/ _jsx(Form, {
                        noValidate: true,
                        onSubmit: function(e) {
                            e.preventDefault();
                        },
                        children: /*#__PURE__*/ _jsxs("fieldset", {
                            disabled: formdisabled,
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "card pagezoom card-st-3 mb-4",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "card-body px-xl-3",
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: "pt-3 px-3",
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "row gx-xl-4",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-xl-3 col-md-12",
                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                            className: "mb-2 form-st-3 pb-1",
                                                            children: [
                                                                /*#__PURE__*/ _jsxs(Form.Label, {
                                                                    className: "mb-1",
                                                                    children: [
                                                                        "รหัสโปรโมชัน",
                                                                        /*#__PURE__*/ _jsx("span", {
                                                                            className: "text-danger",
                                                                            children: " *"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                    type: "text",
                                                                    name: "set_promotion_code",
                                                                    className: "form-control",
                                                                    placeholder: "รหัสโปรโมชัน",
                                                                    value: values.set_promotion_code,
                                                                    isInvalid: !!errors.set_promotion_code,
                                                                    onChange: function(e) {
                                                                        setFieldValue("set_promotion_code", e.target.value);
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-xl-3 col-md-12",
                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                            className: "mb-2 form-st-3 pb-1",
                                                            children: [
                                                                /*#__PURE__*/ _jsxs(Form.Label, {
                                                                    className: "mb-1",
                                                                    children: [
                                                                        "ชื่อโปรโมชัน",
                                                                        /*#__PURE__*/ _jsx("span", {
                                                                            className: "text-danger",
                                                                            children: " *"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                    type: "text",
                                                                    name: "set_promotion_name",
                                                                    className: "form-control",
                                                                    placeholder: "ชื่อโปรโมชัน",
                                                                    value: values.set_promotion_name,
                                                                    isInvalid: !!errors.set_promotion_name,
                                                                    onChange: function(e) {
                                                                        setFieldValue("set_promotion_name", e.target.value);
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-xl-3 col-md-12",
                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                            className: "mb-3 form-st-3 pb-1",
                                                            children: [
                                                                /*#__PURE__*/ _jsxs(Form.Label, {
                                                                    className: "mb-1",
                                                                    children: [
                                                                        "วันที่เริ่มต้น",
                                                                        " ",
                                                                        /*#__PURE__*/ _jsx("span", {
                                                                            className: "text-danger",
                                                                            children: " *"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsx(DatePicker, {
                                                                    inputFormat: "DD/MM/YYYY",
                                                                    dateFormat: "dd/MM/yyyy",
                                                                    placeholderText: "วันที่เริ่มต้น",
                                                                    selected: values.set_promotion_sdate,
                                                                    isInvalid: !!errors.set_promotion_sdate,
                                                                    onChange: function(date) {
                                                                        setFieldValue("set_promotion_sdate", date);
                                                                    },
                                                                    className: "w-100 datepicker2 ".concat(values.set_promotion_sdate ? "" : !!errors.set_promotion_sdate ? "is-invalid" : ""),
                                                                    value: values.set_promotion_sdate
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-xl-3 col-md-12",
                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                            className: "mb-3 form-st-3 pb-1",
                                                            children: [
                                                                /*#__PURE__*/ _jsxs(Form.Label, {
                                                                    className: "mb-1",
                                                                    children: [
                                                                        "วันที่สิ้นสุด",
                                                                        " ",
                                                                        /*#__PURE__*/ _jsx("span", {
                                                                            className: "text-danger",
                                                                            children: " *"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsx(DatePicker, {
                                                                    inputFormat: "DD/MM/YYYY",
                                                                    dateFormat: "dd/MM/yyyy",
                                                                    placeholderText: "วันที่สิ้นสุด",
                                                                    selected: values.set_promotion_edate,
                                                                    isInvalid: !!errors.set_promotion_edate,
                                                                    onChange: function(date) {
                                                                        setFieldValue("set_promotion_edate", date);
                                                                    },
                                                                    className: "w-100 datepicker2 ".concat(values.set_promotion_edate ? "" : !!errors.set_promotion_edate ? "is-invalid" : ""),
                                                                    value: values.set_promotion_edate
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-xl-3 col-md-12",
                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                            className: "mb-2 form-st-3 pb-1",
                                                            children: [
                                                                /*#__PURE__*/ _jsxs(Form.Label, {
                                                                    className: "mb-1",
                                                                    children: [
                                                                        "ประเภทโปรโมชัน",
                                                                        /*#__PURE__*/ _jsx("span", {
                                                                            className: "text-danger",
                                                                            children: " *"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsx(Select, {
                                                                    as: "select",
                                                                    name: "set_promotion_type",
                                                                    onChange: function(e) {
                                                                        setFieldValue("set_promotion_type", e.value);
                                                                    },
                                                                    z: true,
                                                                    className: !!errors.set_promotion_type ? "w-100 select-st-1 isInvalid " : "w-100 select-st-1",
                                                                    options: optionsMstPromotionType,
                                                                    placeholder: "เลือกประเภทโปรโมชัน",
                                                                    value: optionsMstPromotionType.filter(function(item) {
                                                                        return item.value === values.set_promotion_type;
                                                                    }),
                                                                    isInvalid: !!errors.set_promotion_type
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    "set_promotion_type" in values && (values.set_promotion_type == "1" || values.set_promotion_type == "2") && /*#__PURE__*/ _jsxs(_Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-3 col-md-12",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: [
                                                                                "ส่วนลด",
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    className: "text-danger",
                                                                                    children: " *"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "set_promotion_discount",
                                                                            className: "form-control",
                                                                            placeholder: "ส่วนลด",
                                                                            value: values.set_promotion_discount,
                                                                            isInvalid: !!errors.set_promotion_discount,
                                                                            onChange: function(e) {
                                                                                return handleChange(e);
                                                                            }
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-3 col-md-12",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: [
                                                                                "ระดับ",
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    className: "text-danger",
                                                                                    children: " *"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Select, {
                                                                            as: "select",
                                                                            name: "set_promotion_unitid",
                                                                            onChange: function(e) {
                                                                                setFieldValue("set_promotion_unitid", e.value);
                                                                            },
                                                                            z: true,
                                                                            className: !!errors.set_promotion_unitid ? "w-100 select-st-1 isInvalid " : "w-100 select-st-1",
                                                                            options: optionsMstUnit,
                                                                            placeholder: "เลือกระดับ",
                                                                            value: optionsMstUnit.filter(function(item) {
                                                                                return item.value === values.set_promotion_unitid;
                                                                            }),
                                                                            isInvalid: !!errors.set_promotion_unitid
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    "set_promotion_type" in values && values.set_promotion_type == "3" && /*#__PURE__*/ _jsxs(_Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-3 col-md-12",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: [
                                                                                "จำนวนซื้อ",
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    className: "text-danger",
                                                                                    children: " *"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "number",
                                                                            name: "set_promotion_buy",
                                                                            className: "form-control",
                                                                            placeholder: "จำนวนซื้อ",
                                                                            value: values.set_promotion_buy,
                                                                            isInvalid: !!errors.set_promotion_buy,
                                                                            onChange: function(e) {
                                                                                return handleChange(e);
                                                                            }
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-3 col-md-12",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: [
                                                                                "จำนวนแถม",
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    className: "text-danger",
                                                                                    children: " *"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "number",
                                                                            name: "set_promotion_free",
                                                                            className: "form-control",
                                                                            placeholder: "จำนวนแถม",
                                                                            value: values.set_promotion_free,
                                                                            isInvalid: !!errors.set_promotion_free,
                                                                            onChange: function(e) {
                                                                                return handleChange(e);
                                                                            }
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-xl-12 col-md-12",
                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                            className: "mb-2 form-st-3 pb-1",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                    className: "mb-1",
                                                                    children: "หมายเหตุ"
                                                                }),
                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                    type: "text",
                                                                    name: "set_promotion_remark",
                                                                    className: "form-control",
                                                                    placeholder: "หมายเหตุ",
                                                                    value: values.set_promotion_remark,
                                                                    onChange: function(e) {
                                                                        setFieldValue("set_promotion_remark", e.target.value);
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-xl-12 col-md-1",
                                                        children: /*#__PURE__*/ _jsx(Form.Label, {
                                                            className: "mt-2 pt-2 tc-10",
                                                            children: "สถานะ"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-xl-12 col-md-3",
                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Form.Check, {
                                                                    inline: true,
                                                                    type: "radio",
                                                                    id: "p-radio-1",
                                                                    label: "เปิดใช้งาน",
                                                                    checked: status == 1 ? true : false,
                                                                    className: "form-check-st-2 tc-7 mt-3",
                                                                    onChange: function() {
                                                                        setStatus(1);
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ _jsx(Form.Check, {
                                                                    inline: true,
                                                                    type: "radio",
                                                                    id: "p-radio-2",
                                                                    label: "ปิดใช้งาน",
                                                                    checked: status == 2 ? true : false,
                                                                    className: "form-check-st-2 tc-7 mt-3",
                                                                    onChange: function() {
                                                                        setStatus(2);
                                                                    }
                                                                })
                                                            ]
                                                        }, "p-radio")
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "card pagezoom card-st-3  mb-4",
                                    style: {
                                        minWidth: "1000px"
                                    },
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "card-body px-xl-3 d-flex ",
                                        children: [
                                            /*#__PURE__*/ _jsx(Button, {
                                                type: "button",
                                                onClick: function(e) {
                                                    navigate("/promotion");
                                                },
                                                className: "btn-st-6 me-3 btn ms-auto",
                                                children: "ยกเลิก"
                                            }),
                                            /*#__PURE__*/ _jsx(Button, {
                                                type: "submit",
                                                className: "bnt btn-dg",
                                                onClick: function(e) {
                                                    handleSubmit();
                                                    e.preventDefault();
                                                },
                                                children: "บันทึก"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    });
                }
            })
        ]
    });
}
export function DelModel(param) {
    var modal = param.modal, setModal = param.setModal, setTextsuccess = param.setTextsuccess, setModalsuccess = param.setModalsuccess, setIsLoading = param.setIsLoading, setModalObj = param.setModalObj, modalObj = param.modalObj, dataID = param.dataID;
    var _modal_data;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState(0), 2), id = _useState[0], setId = _useState[1];
    var deletePromotionReducer = useAppSelector(function(state) {
        return state.deletePromotionReducer;
    });
    useEffect(function() {
        setIsLoading(deletePromotionReducer.isFetching);
        if (deletePromotionReducer.data && !deletePromotionReducer.isError) {
            setTextsuccess("ลบสาขาสำเร็จ");
            setModalsuccess(true);
            dispatch(cleardeletePromotion());
            dispatch(allPromotion({
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
        }
    }, [
        deletePromotionReducer
    ]);
    useEffect(function() {
        if (modal.data != null) {
            var vul = modal.data;
            setId(vul.id);
        }
    }, [
        modal.data,
        modal.open
    ]);
    var onClickModel = function() {
        if (modal.typeData == "deletePromotion") {
            var data = {
                set_promotion_id: id
            };
            dispatch(deletePromotion(data, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    };
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "px-3 py-4",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "text-center fs-24 tc-5 my-4",
                    children: "คุณต้องการลบข้อมูลนี้"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "text-center fs-24 my-6",
                    children: (_modal_data = modal.data) === null || _modal_data === void 0 ? void 0 : _modal_data.name
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "text-center mt-5",
                    children: [
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-st-6 me-3",
                            onClick: function() {
                                return setModal(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: false
                                    });
                                });
                            },
                            children: "ยกเลิก"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-dg",
                            onClick: function(e) {
                                onClickModel();
                            },
                            children: "ยืนยัน"
                        })
                    ]
                })
            ]
        })
    });
}
